module.exports = __webpack_public_path__ + "static/media/send-your-story-tips.e455f0f5.png";